import { JSONEditor } from '@json-editor/json-editor'

const iconPrefix = 'icon-'
const mapping = {
  collapse: 'chevron-down',
  expand: 'chevron-up',
  delete: 'trash',
  replace: 'flip',
  edit: 'gear',
  edit_properties: 'gear',
  add: 'plus',
  copy: 'duplicate',
  cancel: 'ban-circle',
  save: 'ok',
  moveup: 'arrow-u',
  movedown: 'arrow-d',
  moveleft: 'arrow-l',
  moveright: 'arrow-r',
  clear: 'remove-circle',
  time: 'time',
  calendar: 'calendar',
  book: 'book'
}

class LXPIconLib extends JSONEditor.AbstractIconLib {
  constructor () {
    super(iconPrefix, mapping)
  }
}

export default LXPIconLib
